const puwyloBatchDataSelector = store => store.p13n?.puwyloBatchData;

export { puwyloBatchDataSelector };
